import { cn } from '@/utils/cn';
import React from 'react';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, required, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          'block text-xs font-semibold text-ui-body mb-1',
          className
        )}
        {...props}
      >
        {children}
        {required && <span className="text-ui-error ml-1">*</span>}
      </label>
    );
  }
);

Label.displayName = 'Label';

export default Label;
